(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './BackArrow', './Eye', './EyeSlash', './PeachjarLogo', './CircleCheck', './ApproverFlyer'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./BackArrow'), require('./Eye'), require('./EyeSlash'), require('./PeachjarLogo'), require('./CircleCheck'), require('./ApproverFlyer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.BackArrow, global.Eye, global.EyeSlash, global.PeachjarLogo, global.CircleCheck, global.ApproverFlyer);
    global.index = mod.exports;
  }
})(this, function (exports, _BackArrow, _Eye, _EyeSlash, _PeachjarLogo, _CircleCheck, _ApproverFlyer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, 'BackArrow', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_BackArrow).default;
    }
  });
  Object.defineProperty(exports, 'Eye', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_Eye).default;
    }
  });
  Object.defineProperty(exports, 'EyeSlash', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_EyeSlash).default;
    }
  });
  Object.defineProperty(exports, 'PeachjarLogo', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_PeachjarLogo).default;
    }
  });
  Object.defineProperty(exports, 'CircleCheck', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_CircleCheck).default;
    }
  });
  Object.defineProperty(exports, 'ApproverFlyer', {
    enumerable: true,
    get: function () {
      return _interopRequireDefault(_ApproverFlyer).default;
    }
  });

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/svg/index.js
// module id = 215
// module chunks = 1